const medicineBazarBn = {
	search: {
		placeholders: [
			'ওষুধের নাম লিখুন...',
			'জেনেরিক নাম লিখুন...',
			'কোম্পানির নাম লিখুন...',
			'ব্রান্ডের নাম লিখুন...',
			'দোকানের নাম লিখুন...'
		]
	},
	sidebar: {
		categoriesTitle: 'ক্যাটেগরি',
		storesTitle: 'দোকানের তালিকা'
	},
	upload: {
		title: 'প্রেসক্রিপশন আপলোড',
		subtitle: 'আপনার ডাক্তারের প্রেসক্রিপশন আপলোড করুন এবং সহজেই ঔষধ অর্ডার করুন',
		uploadedPrefix: '✓ ফাইল আপলোড হয়েছে:',
		chooseFile: 'ফাইল নির্বাচন করুন',
		replaceFile: 'নতুন ফাইল আপলোড'
	},
	store: {
		serviceAreaLabel: 'সেবা এলাকা',
		nationwide: 'সারাদেশ',
		medicineCountLabel: 'ঔষধের সংখ্যা',
		close: 'বন্ধ করুন',
		productsOfSuffix: 'এর ঔষধসমূহ',
		descriptionPrefix: 'নিচে',
		descriptionSuffix: 'ফার্মেসির সকল উপলব্ধ ঔষধ দেখানো হয়েছে। আপনি চাইলে ক্যাটেগরি অনুযায়ী ফিল্টার করতে পারেন।'
	},
	card: {
		addToCart: 'ব্যাগে নিন'
	},
	empty: {
		title: 'কোন ঔষধ পাওয়া যায়নি',
		subtitle: 'অন্য ক্যাটেগরি বা ফার্মেসি নির্বাচন করুন'
	},
	prescriptionFlow: {
		successTitle: 'প্রেসক্রিপশন সফলভাবে আপলোড হয়েছে!',
		instruction: 'এখন আপনার ঔষধ অর্ডারের জন্য নিচের তথ্যগুলো পূরণ করুন',
		step1: {
			title: 'ফার্মেসি নির্বাচন করুন',
			subtitle: 'কোন ফার্মেসি থেকে ঔষধ কিনতে চান?',
			next: 'পরবর্তী'
		},
		step2: {
			title: 'কোর্সের মেয়াদ নির্বাচন করুন',
			subtitle: 'কত দিনের জন্য ঔষধ কিনতে চান?',
			fullCourse: 'সম্পূর্ণ কোর্স',
			fiveDays: '৫ দিনের জন্য',
			tenDays: '১০ দিনের জন্য',
			customDays: 'কাস্টম দিন',
			customDaysLabel: 'কত দিনের জন্য?',
			customDaysPlaceholder: 'যেমন: ১৫',
			back: 'পূর্ববর্তী',
			next: 'পরবর্তী'
		},
		step3: {
			title: 'অর্ডার নিশ্চিত করুন',
			summaryTitle: 'আপনার অর্ডারের সারসংক্ষেপ:',
			pharmacyLabel: 'ফার্মেসি',
			durationLabel: 'কোর্সের মেয়াদ',
			prescriptionLabel: 'প্রেসক্রিপশন',
			back: 'পূর্ববর্তী',
			confirm: 'অর্ডার নিশ্চিত করুন'
		},
		snackbar: {
			successTitle: '🎉 অর্ডার সফলভাবে জমা দেওয়া হয়েছে!',
			message: 'আপনার নির্ধারিত ফার্মেসি থেকে শীঘ্রই আপনার সাথে যোগাযোগ করা হবে দাম এবং অন্যান্য বিস্তারিত তথ্যের জন্য।'
		}
	}
};

export default medicineBazarBn;


